import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth uses an httpOnly cookie (same-origin); no tokens in localStorage.
const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => `${API}/files/${path}`;

export function formatApiError(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
}

export default api;
